"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styles = require("@material-ui/core/styles");
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _excluded = ["open", "children"];
var useStyles = (0, _styles.makeStyles)({
  // Need to be lower than detail modal
  popper: {
    zIndex: '1000!important'
  },
  tooltip: {
    background: 'var(--color-primary)',
    fontSize: 'inherit',
    padding: '0.75rem 1rem',
    top: -10,
    left: -5
  },
  arrow: {
    left: '5px!important',
    color: 'var(--color-primary)'
  }
});
var ProTip = function ProTip(_ref) {
  var open = _ref.open,
    children = _ref.children,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], (0, _extends2["default"])({}, rest, {
    arrow: true,
    open: open,
    title: /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-white"
    }, /*#__PURE__*/_react["default"].createElement("h4", {
      className: "text-sm"
    }, t('tooltip.protip.title')), /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-xs font-light"
    }, t('retrofit.protip.description'))),
    classes: classes,
    placement: "bottom-start"
  }), children);
};
var _default = exports["default"] = ProTip;
//# sourceMappingURL=ProTip.js.map